import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page10',
  templateUrl: './armenia-page10.component.html',
  styleUrls: ['./armenia-page10.component.css']
})
export class ArmeniaPage10Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
